/* global $ */
import { core } from '@/core'
import Basic from '@basic'
import { Input } from '@bag'
import CascaderDropdown from './CascaderDropdown.js'
import CascaderPanel from './CascaderPanel.js'

const util = {
  pullInput(opt, tar) {
    const option = {
      type: 'text',
      placeholder: opt.placeholder,
      readonly: true,
      suffix: 'angle-up',
    }
    const input = new Input(Object.assign({}, opt, option))
    tar.unit.append(input.unit)
    return input
  },
  pullDropdown(opt, tar) {
    const dropdown = new CascaderDropdown({})
    dropdown.width = tar.input.unit.width()
    tar.unit.append(dropdown.unit)
    return dropdown
  },
  pullPanel(opt, tar) {
    const option = {
      emptyMember: tar.members.empty
    }
    Object.assign(option, opt)
    const panel = new CascaderPanel(option)
    panel.click($.proxy(tar.handleOptionClick, tar))
    tar.dropdown.slot = panel.unit
    return panel
  },
  template: {
    cascader() {
      return $('<div class="lt-cascader"><p id="empty" class="select-dropdown__empty"></p></div>')
    },
  },
  updater: {
    // 原生类
    name(value, opt, tar, node) {
      if (value || value === '') {
        tar.input.disabled = true
      } else {
        tar.input.disabled = false
      }
    },
    disabled(value, opt, tar, node) {
      if (value || value === '') {
        tar.input.disabled = true
      } else {
        tar.input.disabled = false
      }
    },
    // 基本类
    border(value, opt, tar, node) {
      if (value || value === '') {
        tar.unit.addClass('is-bordered')
      } else {
        tar.unit.removeClass('is-bordered')
      }
    },
    valueArray(value, opt, tar, node) {
      const { option = [] } = tar.members
      if ($.type(value) === 'string' && value) {
        tar.valueArray = value.split(',')
      } else if ($.type(value) === 'array') {
        option.some(obj => {
          obj.selected = value.includes(obj.value)
        })
      } else {
        tar.valueArray = []
      }
    },
    size(value, opt, tar, node) {
      tar.input.size = value
    },
    // 扩展类
    clearable(value, opt, tar, node) {
      tar.input.clearable = value
    },
    multiple(value, opt, tar, node) {
      if (value) {
        // TODO: 未完成
      } else {
        // tar.members.tags.detach()
      }
    },
    filterable(value, opt, tar, node) {
      // TODO: 未完成
      if (value) {
        tar.input.readonly = false
      } else {
        tar.input.readonly = true
      }
    },
  },
}

function flatMapData(last, item, opt, pid = '') {
  const { dataId, dataChildren, dataPid } = opt
  item[dataPid] = pid
  last.push(item)
  if (item[dataChildren] && item[dataChildren].length) {
    item.children.reduce((lastK, itemK) => {
      return flatMapData(lastK, itemK, opt, item[dataId])
    }, last)
  }
  return last
}

function unFlatMapData(last, item, opt, value = '') {
  const { dataPid, dataChildren, flatData, dataId, dataText } = opt
  const pid = item[dataId]
  item[dataChildren] = flatData
    .filter((x) => x[dataPid] === pid && x[dataText].includes(value))
    .reduce((lastD, itemD) => {
      return unFlatMapData(lastD, itemD, opt, value)
    }, [])
  last.push(item)
  return last
}

export default class Cascader extends Basic {
  constructor(opt) {
    super(opt)
    const def = {
      type: 'cascader', // 控件类型
      placeholder: '', // 原生属性: placeholder
      dataFlatType: true, // 数据为递归完成的
      dataId: 'id', // data数据 的 id自定义Key
      dataText: 'name', // data数据 的 text自定义Key
      dataChildren: 'children', // data数据 的 children自定义Key
      dataPid: 'pid', // data数据 的 pid自定义Key
      dataHighPid: '', // 最高级别的pid值
      dataJoin: '-', // 多级字符显示连接符
      dataLast: 0, // 删除头几级的字符串
      dataAll: false, // 开启多级显示
      defaultData: [
        // 默认选项值
        { id: '1', text: '是' },
        { id: '0', text: '否' },
      ],
    }
    this.defaults = {
      name: '', // 原生属性: 控件名
      disabled: false, // 原生属性: 禁用(true/false)

      border: false, // 基本功能: 是否显示边框
      valueArray: [], // 基本功能: 值
      size: '', // 基本功能: 尺寸

      clearable: true, // 扩展功能: 是否可清空(true/false)
      multiple: false, // 扩展功能: 是否能多选
      filterable: true, // 扩展功能: 是否可搜索
    }
    this.events = {
      reset: null, // 重置data
      change: 'onChange', // input的值变化事件
      focus: 'onFocus', // input的获得焦点事件
      blur: 'onBlur', // input的失去焦点事件
      click: null, // input的点击事件
      shown: null, // 弹窗panel出现后事件
      hidden: null, // 弹窗panel隐藏后事件
    }
    this.settings = Object.assign({}, def, this.defaults, opt)
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.cascader(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    this.input = util.pullInput(opt, this)
    this.dropdown = util.pullDropdown(opt, this)
    this.panel = util.pullPanel(opt, this)
    this.data = this.settings.data
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  bindInput() {
    this.input.input($.proxy(this.handleInputKeyup, this))
    this.input.click($.proxy(this.click, this))
    this.input.focus($.proxy(this.focus, this))
    this.input.blur($.proxy(this.blur, this))
    this.input.erase($.proxy(this.handleClear, this))
    this.dropdown.shown($.proxy(this.handleShown, this))
    this.dropdown.hidden($.proxy(this.hidden, this))
    $(window).click($.proxy(this.handleDropdown, this))
  }

  handleClear(obj) {
    this.value = ''
    this.panel.data = this.settings.data
  }

  handleShown(obj) {
    if (obj.show) {
      this.input.members.suffixIcon.addClass('is-reverse')
      this.hasLocation(this.unit, this.dropdown.unit, window)
      this.panel.reset()
    } else {
      this.input.members.suffixIcon.removeClass('is-reverse')
    }
    this.shown()
  }

  handleDropdown(event) {
    const input = $(event.target).closest(this.input.members.input)
    const dropdown = $(event.target).closest(this.dropdown.unit)
    if (input.length > 0) {
      this.dropdown.show = true
    } else if (dropdown.length > 0) {
      this.dropdown.show = this.key
    } else if (event.target.tagName === 'BODY') {
    } else if (this.dropdown.show) {
      this.dropdown.show = false
    }
  }

  handleInputKeyup(obj) {
    const { dataText, dataPid, dataHighPid } = this.settings
    const value = obj.value
    const filterData = this.settings.flatData
      .filter((x) => !(x[dataPid] && x[dataPid].trim() && x[dataPid].trim() !== dataHighPid) && x[dataText].includes(value))
      .reduce((last, item) => {
        return unFlatMapData(last, item, this.settings, value)
      }, [])
    this.panel.data = filterData
    this.dropdown.show = true
  }

  handleOptionClick(obj) {
    this.value = [obj.value]
    this.input.members.input.focus()
    this.change()
  }

  onChange() {
    this.input.value = this.textContent
  }

  onFocus() {
    this.dropdown.show = true
    this.panel.data = this.settings.data
  }

  onBlur() {
    this.input.value = this.textContent
  }

  rollValue(val, lvl = 0, list = []) {
    const { dataId, dataPid, dataHighPid } = this.settings
    const lvlNext = lvl + 1
    this.flatData
      .filter((x) => val.includes(x[dataId]))
      .forEach((x) => {
        if (x[dataPid] && x[dataPid].trim() && x[dataPid] !== dataHighPid) {
          this.rollValue([x.pid], lvlNext, list)
        }
        if (!list[lvl]) list[lvl] = []
        list[lvl].push(x.id)
      })
    return list
  }

  set data(value = this.settings.defaultData) {
    // this.settings.dataAll = true
    // this.settings.dataJoin = 'xx'
    // this.settings.dataLast = 1
    if (this.settings.dataFlatType) {
      this.settings.data = value
      // this.settings.data = [
      //   {
      //     id: '11',
      //     name: '1',
      //     children: [
      //       { id: '2', name: '11' },
      //       {
      //         id: '3',
      //         name: '22',
      //         children: [
      //           { id: '4', name: '111' },
      //           { id: '5', name: '222' },
      //         ],
      //       },
      //     ],
      //   },
      //   { id: '6', name: '23' },
      //   { id: '12', name: '41' },
      //   { id: '13', name: '3123' },
      //   { id: '14', name: '2211' },
      //   { id: '15', name: '11144' },
      //   { id: '21', name: '55533' },
      // ]
      this.settings.flatData = this.settings.data.reduce((last, item) => {
        return flatMapData(last, item, this.settings, this.settings.dataHighPid)
      }, [])
    } else {
      this.settings.flatData = value
      // this.settings.flatData = [
      //   { id: '2', text: '1' },
      //   { id: '3', text: '23', pid: '2' },
      //   { id: '4', text: '24', pid: '2' },
      //   { id: '5', text: '25', pid: '2' },
      //   { id: '6', text: '26', pid: '2' },
      //   { id: '11', text: '41', pid: '4' },
      //   { id: '12', text: '42', pid: '4' },
      //   { id: '13', text: '43', pid: '4' },
      //   { id: '14', text: '44', pid: '4' },
      //   { id: '15', text: '45', pid: '4' },
      //   { id: '21', text: '46', pid: '4' },
      //   { id: '22', text: '47', pid: '4' },
      // ]
      const { dataPid, dataHighPid } = this.settings
      this.settings.data = this.settings.flatData
        .filter((x) => !(x[dataPid] && x[dataPid].trim() && x[dataPid].trim() !== dataHighPid))
        .reduce((last, item) => {
          return unFlatMapData(last, item, this.settings)
        }, [])
    }
    this.panel.data = this.settings.data
  }

  get data() {
    return this.settings.data
  }

  set value(value) {
    this.valueArray = value
    this.valueArrays = this.rollValue(value).reverse()
    this.panel.value = this.valueArrays || []
    this.input.value = this.textContent
  }

  get value() {
    const arr = this.valueArray || []
    return arr.join(',')
  }

  get flatData() {
    return this.settings.flatData
  }

  get textContent() {
    const { dataId, dataText, dataJoin, dataLast, dataAll } = this.settings
    if (dataAll) {
      const valueArr = this.panel.value.split(',')
      let rArr = valueArr
      if (valueArr.length > dataLast) {
        rArr = valueArr.slice(dataLast, valueArr.length)
      }
      return this.flatData.filter(x => rArr.includes(x[dataId])).map((x) => x[dataText]).join(dataJoin)
    }
    return this.flatData
      .filter(x => this.valueArray.includes(x[dataId]))
      .map(x => x[dataText])
      .join(',')
  }
}
